import React from 'react';
import { Image } from 'antd';
import logo from '../Assets/logo_whitee.png';
import bgMedia from '../Assets/logo.png'
import { ThreeDots } from 'react-loader-spinner';

const CustomLazyLoading = () => {
    return (
        <div style={{ height: '100vh', display: "flex", justifyContent: "center", alignItems: "center", background: "#F99760" }}>
            <div>
                <Image preview={false} src={logo} height={140} />
                </div>
        </div>
    )
}

export default CustomLazyLoading